/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICustomImageBannerData } from './custom-image-banner.data';
import { ICustomImageBannerProps } from './custom-image-banner.props.autogenerated';

export interface ICustomImageBannerViewProps extends ICustomImageBannerProps<ICustomImageBannerData> {}

/**
 *
 * CustomImageBanner component
 * @extends {React.PureComponent<ICustomImageBannerProps<ICustomImageBannerData>>}
 */
class CustomImageBanner extends React.PureComponent<ICustomImageBannerProps<ICustomImageBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CustomImageBanner;
